import React, { useEffect } from 'react';
import { WindowUtils } from 'msal';
import { authenticatingUser, authenticatingUserSuccess } from 'redux/actions/auth';
import { authAgent, getAccessTokenSilent, getAccessTokenInteractive } from 'auth/authUtils';
import { useDispatch, useSelector } from 'react-redux';
import { getAdminSiteIds, getCategories } from 'redux/thunks/sites';
import { getUserFavorites } from 'redux/thunks/user';

import { useHistory } from 'react-router';

/* 
	Derived from
	https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/samples/msal-core-samples/react-sample-app/src/AuthProvider.js
    
	More useful reading on MSAL can be found here
	https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-core/docs/FAQ.md
*/

const withAuth = (PassedComponent) => {
    const WithAuth = (props) => {
        const dispatch = useDispatch();
        const accessToken = useSelector((state) => state.user.accessToken);
        const { ...cleanedProps } = props;
        const history = useHistory();

        useEffect(() => {
            const getToken = async () => {
                const accessTokenResult = await acquireToken();

                if (accessTokenResult) {
                    dispatch(
                        authenticatingUserSuccess(
                            accessTokenResult.accessToken,
                            accessTokenResult.expiresOn,
                            accessTokenResult.account.name,
                            accessTokenResult.account.userName
                        )
                    );
                }
            };

            const msalAccount = authAgent.getAccount();

            if (accessToken) {
                dispatch(getCategories());
                dispatch(getAdminSiteIds());
                dispatch(getUserFavorites());

                let previousUrl = localStorage.getItem('previousUrl');
                if (previousUrl) {
                    history.push(previousUrl);
                    localStorage.removeItem('previousUrl');
                }
            }

            if (!WindowUtils.isInIframe()) {
                if (msalAccount && !accessToken) {
                    dispatch(authenticatingUser());
                    getToken();
                }
            }
        }, [accessToken, dispatch, history]);

        const acquireToken = async () => {
            return await getAccessTokenSilent(authAgent)
                .then((success) => {
                    return success;
                })
                .catch((error) => {
                    console.warn('Error occurred acquiring token silently');
                    getAccessTokenInteractive();
                });
        };

        if (WindowUtils.isInIframe()) {
            return <></>;
        } else {
            return <PassedComponent {...cleanedProps} />;
        }
    };

    return WithAuth;
};

export default withAuth;
